<template>
  <div class="space-y-6">
    <div class="flex justify-between items-center mb-2">
      <h2 class="text-2xl font-bold text-gray-800">Company Information</h2>
      <button
        class="bg-brand-black p-3 rounded-xl text-white cursor-pointer disabled:bg-opacity-10 disabled:cursor-not-allowed"
        :disabled="!isFormComplete"
        @click="handleSave"
      >
        Save Changes
      </button>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="space-y-4">
        <div>
          <Label for="name">Company Name</Label>
          <Input id="name" v-model="companyInfo.name" />
        </div>

        <div>
          <Label for="tagline">Tagline</Label>
          <Input id="tagline" v-model="companyInfo.tag_line" />
        </div>

        <div>
          <Label for="company_category">Company Category</Label>
          <!-- <Input id="company_category" v-model="companyInfo.company_category" /> -->
          <select
            required
            @change="setCategoryDetails"
            v-model="companyInfo.company_category"
            id="role-type"
            name="role-type"
            autocomplete="role-type"
            class="capitalize flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus-visible:outline-none"
          >
            <option disabled value="">Select One</option>
            <option class="" v-for="item in companyCategories" :key="item.key" :value="item.key">
              {{ item.value }}
            </option>
          </select>
        </div>

        <div>
          <Label for="location">Location</Label>
          <Input id="location" v-model="companyInfo.location" />
        </div>
      </div>

      <div class="space-y-4">
        <div>
          <Label for="worktype">Work Type</Label>
          <select
            required
            v-model="companyInfo.work_type"
            id="work_type"
            name="work_type"
            autocomplete="role-type"
            class="capitalize flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus-visible:outline-none"
          >
            <option disabled value="">Select One</option>
            <option class="" v-for="item in workType" :key="item.key" :value="item.key">
              {{ item.value }}
            </option>
          </select>
          <!-- <Input id="worktype" v-model="companyInfo.work_type" /> -->
        </div>

        <div>
          <Label for="companysize">Company Size</Label>
          <Input id="companysize" v-model="companyInfo.company_size" />
        </div>

        <div class="space-y-4">
          <!-- <h3 class="text-lg font-medium">Media Links</h3> -->

          <div class="flex flex-col gap-2">
            <Label>Company website</Label>
            <Input id="website" v-model="companyInfo.website" placeholder="Website URL" />
          </div>
          <div>
            <div v-for="(item, index) in companyInfo.social_links" :key="index" class="flex flex-col gap-2 mb-3">
              <Input id="label" v-model="item.platform" placeholder="Facebook" />
              <div class="flex items-start">
                <Input v-model="item.url" type="url" placeholder="https://example.com" />
                <!--Remove Svg Icon-->
                <svg
                  v-show="companyInfo.social_links.length > 1"
                  @click.prevent="removeField(index, companyInfo.social_links)"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  class="ml-2 cursor-pointer"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="#000"
                    d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
                  />
                </svg>
              </div>
            </div>

            <div class="px-4">
              <div class="flex w-fit cursor-pointer add-btn" @click.prevent="addField()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M9.16602 15.8334C9.16602 16.2937 9.53911 16.6667 9.99935 16.6667C10.4596 16.6667 10.8327 16.2937 10.8327 15.8334V10.8334H15.8327C16.2929 10.8334 16.666 10.4603 16.666 10.0001C16.666 9.53985 16.2929 9.16675 15.8327 9.16675H10.8327L10.8327 4.16675C10.8327 3.70651 10.4596 3.33342 9.99935 3.33342C9.53911 3.33342 9.16602 3.70651 9.16602 4.16675L9.16602 9.16675L4.16602 9.16675C3.70578 9.16675 3.33268 9.53984 3.33268 10.0001C3.33268 10.4603 3.70578 10.8334 4.16602 10.8334L9.16602 10.8334V15.8334Z"
                    fill="#000"
                  />
                </svg>
                <h3 class="text-black add ml-1 text-base font-medium leading-5">Add more publication</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      <form id="logoForm">
        <Label for="logo_url">Company Logo</Label>
        <!-- <Input
          id="logo_url"
          v-model="companyInfo.logo_url"
          placeholder="Enter Image URL"
          @input="updatePreview('logo_url')"
        /> -->
        <input type="file" name="file" @change="uploadImage($event, 'logo_url')" class="mt-2" />
        <div class="mt-2 p-4 border border-dashed rounded-md flex items-center justify-center">
          <img v-if="imagePreviews.logo_url" :src="imagePreviews.logo_url" alt="Company logo_url" class="max-h-24 object-contain" />
          <p v-else class="text-gray-500">No logo uploaded</p>
        </div>
      </form>

      <form id="bannerForm">
        <Label for="banner_url">Header Image</Label>
        <!-- <Input
          id="banner_url"
          v-model="companyInfo.banner_url"
          placeholder="Enter Image URL"
          @input="updatePreview('banner_url')" 
        /> -->
        <input type="file" name="file" @change="uploadImage($event, 'banner_url')" class="mt-2" />
        <div class="mt-2 p-4 border border-dashed rounded-md flex items-center justify-center">
          <img v-if="imagePreviews.banner_url" :src="imagePreviews.banner_url" alt="Header Image" class="max-h-24 object-contain" />
          <p v-else class="text-gray-500">No header image uploaded</p>
        </div>
      </form>
    </div>
    <Loading :isLoading="isLoading" className="fixed inset-0 bg-[#1B224B]/[.2] flex justify-center items-center" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import Input from '../ui/Input.vue';
import Label from '../ui/Label.vue';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';

const store = useStore();
const props = defineProps({ companyDetails: { type: Object } });
const emit = defineEmits(['refreshCompanyProfile']);

const isLoading = ref(false);

// Original and edited values
const originalCompanyInfo = ref({});
const companyInfo = ref({
  name: '',
  tag_line: '',
  company_category: '',
  location: '',
  work_type: '',
  company_size: '',
  website: '',
  social_links: [{ platform: '', url: '' }],
  logo_url: '',
  banner_url: '',
});

const companyCategories = ref(null);
const workType = ref([
  { key: 'remote', value: 'Remote' },
  { key: 'hybrid', value: 'Hybrid' },
  { key: 'on_site', value: 'Onsite' },
]);

const imagePreviews = ref({
  logo_url: '',
  banner_url: '',
});

const addField = () => {
  companyInfo.value.social_links.push({ platform: '', url: '' });
};

const removeField = (index) => {
  companyInfo.value.social_links.splice(index, 1);
};

const uploadImage = async (event, field) => {
  const formId = field === 'logo_url' ? 'logoForm' : 'bannerForm';
  const file = event.target.files[0];

  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      imagePreviews.value[field] = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  const formData = new FormData(document.querySelector(`#${formId}`));

  try {
    isLoading.value = true;

    const fileUrl = await store.dispatch('global/uploadFileUrl', formData);
    companyInfo.value[field] = fileUrl;
  } catch (err) {
    console.error('Upload failed:', err.response?.data || err.message);
    alert('Upload failed: ' + (err.response?.data?.message || err.message));
  } finally {
    isLoading.value = false;
  }
};

const isFormComplete = computed(() => {
  return Object.values(companyInfo.value).every((field) => {
    if (Array.isArray(field)) {
      return field.every((item) => item.platform && item.url);
    }
    return field !== '';
  });
});

const hasFieldChanged = (key, value) => {
  const original = originalCompanyInfo.value[key];
  if (Array.isArray(value)) {
    return JSON.stringify(value) !== JSON.stringify(original);
  }
  return value !== original;
};

const handleSave = async () => {
  const payload = {};

  for (const key in companyInfo.value) {
    const value = companyInfo.value[key];
    if (hasFieldChanged(key, value)) {
      payload[key] = value;
    }
  }

  try {
    isLoading.value = true;
    await store.dispatch('auth/updateUserProfile', payload);
    emit('refreshCompanyProfile');
  } catch (error) {
    console.error('Error saving company info:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  isLoading.value = true;
  companyCategories.value = await store.dispatch('global/getCompanyCategory');

  if (props.companyDetails) {
    const details = props.companyDetails;

    // Normalize social links if object
    const normalizedDetails = { ...details };
    if (typeof normalizedDetails.social_links === 'object' && !Array.isArray(normalizedDetails.social_links)) {
      normalizedDetails.social_links = Object.entries(normalizedDetails.social_links).map(([platform, url]) => ({
        platform,
        url,
      }));
    }

    // Fill companyInfo and keep a copy for comparison
    Object.keys(companyInfo.value).forEach((key) => {
      if (normalizedDetails[key] !== undefined && normalizedDetails[key] !== null) {
        companyInfo.value[key] = normalizedDetails[key];
        if (['logo_url', 'banner_url'].includes(key)) {
          imagePreviews.value[key] = normalizedDetails[key];
        }
      }
    });

    originalCompanyInfo.value = JSON.parse(JSON.stringify(companyInfo.value));
  }

  isLoading.value = false;
});
</script>
